var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.pageTitle,
        color: _vm.titleColor,
        icon: "icon-sent",
        returnUrl: _vm.pageReturnUrl,
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          this.capsule === "draft-edit"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("creation_forms.drft_nm"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v("* "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.draftName,
                            expression: "draftName",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: { "text-align": "left" },
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("creation_forms.drft_nm"),
                          disabled: this.readonly,
                        },
                        domProps: { value: _vm.draftName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.draftName = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.accountType === "1"
            ? _c(
                "form-accordion",
                { attrs: { title: _vm.$t("common.formsSubTitle.val_info") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.team_label"))
                            ),
                            _vm.hasForceValidation
                              ? _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "form-control",
                            attrs: {
                              id: "sel1",
                              disabled: _vm.readonly,
                              options: _vm.teamOptions,
                            },
                            model: {
                              value: _vm.id_team,
                              callback: function ($$v) {
                                _vm.id_team = $$v
                              },
                              expression: "id_team",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.accountType === "1" && _vm.hasForceValidation
            ? _c("hr")
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form-accordion",
            { attrs: { title: _vm.$t("attachments.doc"), open: false } },
            [
              _c(
                "b-row",
                { staticClass: "form-group justify-content-start" },
                [
                  !_vm.demo
                    ? _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  disabled: this.readonly,
                                  options: _vm.fileTypeSelect,
                                },
                                model: {
                                  value: _vm.fileIsFacturX,
                                  callback: function ($$v) {
                                    _vm.fileIsFacturX = $$v
                                  },
                                  expression: "fileIsFacturX",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readonly && _vm.typeFile === "1" && !_vm.attachement
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass:
                                "button-round attachmentButton buttonAccordionForm longword-word generalBottomButton",
                              on: {
                                click: function ($event) {
                                  return _vm.openImportAttachment(_vm.typeFile)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.fileIsFacturX
                                      ? "Importer une Factur-X"
                                      : _vm.$t("attachments.import_doc")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readonly && _vm.isSmartphoneOS && _vm.hasCamera
                    ? _c(
                        "div",
                        { staticClass: "col-12 scanbutton" },
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass:
                                "attachmentButton buttonAccordionForm generalBottomButton",
                              attrs: { round: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.scanOrder($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("creation_forms.scn_ordr_form")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", [
                    _vm.typeFile === "1" &&
                    _vm.attachementNameLabel ===
                      _vm.$t("creation_forms.imprt_file")
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.attachementNameLabel,
                              expression: "attachementNameLabel",
                            },
                          ],
                          staticClass: "form-control inputAccordionForm",
                          attrs: {
                            id: "application-file-input",
                            type: "text",
                            placeholder: _vm.$t("creation_forms.slct_a_fl"),
                            readonly: "",
                            disabled: this.readonly,
                          },
                          domProps: { value: _vm.attachementNameLabel },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.attachementNameLabel = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _vm.typeFile === "1" &&
                        _vm.attachementNameLabel !==
                          _vm.$t("creation_forms.imprt_file")
                          ? _c(
                              "label",
                              {
                                attrs: { id: "application-file-input" },
                                model: {
                                  value: _vm.attachementNameLabel,
                                  callback: function ($$v) {
                                    _vm.attachementNameLabel = $$v
                                  },
                                  expression: "attachementNameLabel",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.attachementNameLabel) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex" }, [
                          _vm.typeFile === "1" &&
                          _vm.attachementNameLabel !==
                            _vm.$t("creation_forms.imprt_file")
                            ? _c("i", {
                                staticClass: "icon fa fa-download mx-1",
                                on: {
                                  click: function ($event) {
                                    return _vm.view(_vm.attachmentId)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.typeFile === "1" &&
                          _vm.attachementNameLabel !==
                            _vm.$t("creation_forms.imprt_file")
                            ? _c("i", {
                                staticClass: "icon fa fa-search mx-1",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDoc(_vm.attachmentId)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.typeFile === "2"
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.attachmentId,
                                expression: "attachmentId",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { id: "sel2", readonly: "" },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.attachmentId = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.cloudFileSel()
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", default: "", disabled: "" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      this.hasCloudAttachments
                                        ? _vm.$t("creation_forms.slct_a_fl")
                                        : _vm.$t("attachments.no_document")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.cloudDocsPicker, function (cloudDoc) {
                              return _c(
                                "option",
                                {
                                  key: cloudDoc.id,
                                  domProps: { value: cloudDoc.id },
                                },
                                [_vm._v(" " + _vm._s(cloudDoc.name))]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      key: _vm.refreshImport,
                      staticClass:
                        "item-input hiddenElementAllSize local-file-input",
                      attrs: { type: "file", accept: ".pdf" },
                      on: { change: _vm.onFileChange },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "hiddenElementAllSize",
                      attrs: { type: "text" },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "hiddenElementAllSize",
                      attrs: { type: "text", id: "recommendation-list-input" },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              typeof _vm.attachmentName !== "undefined" &&
              _vm.attachmentName !== ""
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.rfrnc"),
                              placeholderValue: _vm.$t("common.rfrnc_desc"),
                              disabled: this.readonly,
                            },
                            model: {
                              value: _vm.attachmentReference,
                              callback: function ($$v) {
                                _vm.attachmentReference = $$v
                              },
                              expression: "attachmentReference",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.readonly
                ? _c(
                    "b-row",
                    { staticClass: "form-group justify-content-right" },
                    [
                      _vm.isSmartphone
                        ? _c(
                            "b-col",
                            { attrs: { md: "4", "offset-md": "2" } },
                            [
                              _vm.hasAttachment
                                ? _c(
                                    "f7-button",
                                    {
                                      staticClass:
                                        "buttonAccordionForm attachmentButton generalBottomButton",
                                      attrs: { round: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(_vm.attachmentId)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t(
                                              "creation_forms.view_attchmnt"
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          typeof _vm.attachmentName !== "undefined" &&
                          _vm.attachmentName !== ""
                            ? _c(
                                "f7-button",
                                {
                                  staticClass:
                                    "attachmentButton generalBottomButton",
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clearAttachement()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("creation_forms.clear_label")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.readonly && _vm.hasAttachment
                ? _c(
                    "b-row",
                    [
                      _vm.isSmartphone
                        ? _c(
                            "b-col",
                            { attrs: { md: "4", "offset-md": "2" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass:
                                    "buttonAccordionForm attachmentButton",
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(_vm.attachmentId)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("creation_forms.view_attchmnt")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isSmartphone
                        ? _c(
                            "b-col",
                            { attrs: { md: "4", "offset-md": "2" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass:
                                    "buttonAccordionForm attachmentButton",
                                  staticStyle: { width: "200px" },
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(_vm.attachmentId)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("creation_forms.dwnld_attchmnt")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            { attrs: { title: _vm.$t("common.formsSubTitle.item_info_DP") } },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    [
                      _c("form-contact-dropdown-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.nme"),
                          disabled: _vm.readonly,
                          placeholderValue: _vm.$t("creation_forms.bnfcr_nm"),
                          mandatoryErrorIndicator: _vm.beneficiaireError,
                        },
                        on: {
                          "change-iban": function ($event) {
                            _vm.recipientBankAccount = $event
                          },
                          "change-identifier": function ($event) {
                            _vm.recipientEmail = $event
                          },
                          "change-zonecode": function ($event) {
                            return _vm.handleChangeRecipientZoneCode($event)
                          },
                        },
                        model: {
                          value: _vm.beneficiaire,
                          callback: function ($$v) {
                            _vm.beneficiaire = $$v
                          },
                          expression: "beneficiaire",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          disabled: _vm.readonly,
                          inputLabel: _vm.$t("common.idtfr"),
                          placeholderValue: _vm.$t(
                            "creation_forms.bnfcr_email_siren"
                          ),
                          regexpErrorIndicator: _vm.recipientEmailRegexpError,
                        },
                        model: {
                          value: _vm.recipientEmail,
                          callback: function ($$v) {
                            _vm.recipientEmail = $$v
                          },
                          expression: "recipientEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.account_zone")) +
                          "\n            "
                      ),
                      _c("span", { staticClass: "color-red" }, [_vm._v("* ")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.recipientZoneCode,
                            expression: "recipientZoneCode",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { id: "sel4", disabled: _vm.readonly },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.recipientZoneCode = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.countries, function (country) {
                        return _c(
                          "option",
                          {
                            key: country.id,
                            attrs: {
                              disabled:
                                country.disabled ||
                                (!_vm.canSelectOtherThanEuro &&
                                  country.label !== "EUR"),
                            },
                            domProps: {
                              value: country,
                              selected: country.selected,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("zoneCodes." + country.label)) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.recipientZoneCode.accountLabel,
                    function (accountLabel) {
                      return _c(
                        "b-col",
                        { key: accountLabel, staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("bank_accounts.bank_account_singular")
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.recipientZoneCode.values[accountLabel],
                                expression:
                                  "recipientZoneCode.values[accountLabel]",
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              errorBorder:
                                _vm.recipientZoneCode.errors[accountLabel] ===
                                  "missing" ||
                                _vm.recipientZoneCode.errors[accountLabel] ===
                                  "incorrect",
                            },
                            attrs: {
                              type: "text",
                              disabled: _vm.readonly,
                              name: "identifier",
                              placeholder: _vm.$t("common.beneficiaire_name"),
                            },
                            domProps: {
                              value: _vm.recipientZoneCode.values[accountLabel],
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.recipientZoneCode.values,
                                  accountLabel,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.recipientZoneCode.errors[accountLabel] ===
                          "missing"
                            ? _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("errors.is_mandatory", {
                                        mandatoryValue: _vm.$t(accountLabel),
                                      })
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _vm.recipientZoneCode.errors[accountLabel] ===
                              "incorrect"
                            ? _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("errors.is_incorrect", {
                                        incorrectValue: _vm.$t(accountLabel),
                                      })
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            { attrs: { title: _vm.$t("common.formsSubTitle.my_acc_info") } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("select-bank-account", {
                        model: {
                          value: _vm.senderBank,
                          callback: function ($$v) {
                            _vm.senderBank = $$v
                          },
                          expression: "senderBank",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: { title: _vm.$t("common.formsSubTitle.dir_pymnts_dtls") },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-col",
                            { staticStyle: { "padding-left": "1.5em" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.readonly,
                                    value: 1,
                                    "unchecked-value": 0,
                                  },
                                  on: { change: _vm.changeInstPmt },
                                  model: {
                                    value: _vm.instantPayment,
                                    callback: function ($$v) {
                                      _vm.instantPayment = $$v
                                    },
                                    expression: "instantPayment",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("creation_forms.inst_pymnt_form")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.readonly,
                                    value: 1,
                                    "unchecked-value": 0,
                                  },
                                  model: {
                                    value: _vm.decision,
                                    callback: function ($$v) {
                                      _vm.decision = $$v
                                    },
                                    expression: "decision",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "directPayments.dir_pymnt_decision_form"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.rsn"),
                          placeholderValue: _vm.$t("common.rsn"),
                          mandatoryErrorIndicator:
                            _vm.remittanceInformationError,
                          disabled: this.readonly,
                        },
                        model: {
                          value: _vm.remittanceInformation,
                          callback: function ($$v) {
                            _vm.remittanceInformation = $$v
                          },
                          expression: "remittanceInformation",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputType: "date",
                          disablePastDates: "",
                          inputLabel: _vm.$t("common.execution_date_label"),
                          placeholderValue: _vm.$t("common.date_label"),
                          mandatoryErrorIndicator: _vm.executionDateError,
                          disabled: _vm.isInstantPayment || this.readonly,
                        },
                        model: {
                          value: _vm.executionDate,
                          callback: function ($$v) {
                            _vm.executionDate = $$v
                          },
                          expression: "executionDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputType: "number",
                          inputLabel: _vm.$t("common.amnt"),
                          placeholderValue: _vm.$t("common.amnt"),
                          mandatoryErrorIndicator: _vm.amountError,
                          intervalErrorIndicator: _vm.amountIntervalError,
                          disabled: this.readonly,
                        },
                        model: {
                          value: _vm.amount,
                          callback: function ($$v) {
                            _vm.amount = $$v
                          },
                          expression: "amount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.validators.length > 0 ? _c("hr") : _vm._e(),
          _vm._v(" "),
          _vm.validators.length > 0
            ? _c(
                "form-accordion",
                { attrs: { title: _vm.$t("common.formsSubTitle.valid") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c("b-col", [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-striped table-bordered table-status-history",
                          },
                          [
                            _c("thead", { staticClass: "thead-dark" }, [
                              _c("tr", [
                                _c("th", { attrs: { scope: "col" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.status.status_label"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { scope: "col" } }, [
                                  _vm._v(_vm._s(_vm.$t("common.group_label"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { scope: "col" } }, [
                                  _vm._v(_vm._s(_vm.$t("common.vldt_user"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { scope: "col" } }, [
                                  _vm._v(_vm._s(_vm.$t("common.date_vldt"))),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.sortedValidators,
                                function (validator) {
                                  return _c(
                                    "tr",
                                    { key: validator.groupLabel },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "longword dateTimehistoryHeight",
                                        },
                                        [
                                          validator.idAccount !== ""
                                            ? _c(
                                                "span",
                                                [
                                                  _c("f7-icon", {
                                                    staticStyle: {
                                                      "font-size": "16px",
                                                      color: "green",
                                                      "padding-right": "10px",
                                                    },
                                                    attrs: { fa: "check" },
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.vldtd_label"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                [
                                                  _c("f7-icon", {
                                                    staticClass:
                                                      "streammindBlueFont",
                                                    staticStyle: {
                                                      "font-size": "16px",
                                                      "padding-right": "10px",
                                                    },
                                                    attrs: { fa: "clock-o" },
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.wtng_label"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "longword dateTimehistoryHeight",
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(validator.groupLabel)
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "longword dateTimehistoryHeight",
                                        },
                                        [
                                          validator.idAccount !== ""
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(validator.name) +
                                                    "\n                    "
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "item-title-row",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "versionSubTitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              validator.identifier
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            : _c("span", [_vm._v("---")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "showLargeScreenOnly dateTimehistoryHeight",
                                          staticStyle: {
                                            "padding-right": "30px",
                                          },
                                        },
                                        [
                                          validator.idAccount !== ""
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("formatDateTime")(
                                                        validator.horodatage
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "creation_forms.pndng"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.versionNumber > 1 ? _c("hr") : _vm._e(),
          _vm._v(" "),
          _vm.versionNumber > 1
            ? _c(
                "form-accordion",
                { attrs: { title: _vm.$t("common.formsSubTitle.rfsl_hstr") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c("b-col", [
                        _c("label", { staticClass: "labelAccordionForm" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("creation_forms.vrsn")) +
                              "\n            "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n              " +
                                _vm._s(parseInt(_vm.versionNumber) - 1) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("creation_forms.rfsd_by")) +
                              "\n            "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.refuseUsername) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("creation_forms.from")) +
                              "\n            "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.refuseGroupLabel) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(".\n          "),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-row", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "labelAccordionForm" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("creation_forms.rsn_ws")) +
                          ":\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "labelAccordionForm" }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.refuseReason) + "\n        "
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footerButtons" },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c(
                "b-col",
                { attrs: { md: "10", "offset-md": "1" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-end" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          !_vm.readonly
                            ? _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.getNameDraft },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "save" } }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("creation_forms.sv_dp_drft")
                                      ) +
                                      "\n            "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.printValidateButton && !_vm.readonly
                        ? _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.validateAndSaveButton },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "check" } }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("creation_forms.sv_snd_dp_dft")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canSendPayment
                        ? _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.sendDirectPayments },
                                },
                                [
                                  _c("f7-icon", {
                                    attrs: { fa: "paper-plane" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("creation_forms.send_dp")) +
                                      "\n            "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.printValidateButton
                        ? _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.valideDraft },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "check" } }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("creation_forms.vldt"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.printValidateButton && _vm.isHighestValidator
                        ? _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.valideAndSendDraft },
                                },
                                [
                                  _c("f7-icon", {
                                    attrs: { fa: "paper-plane" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("creation_forms.vldt_and_snd")
                                      ) +
                                      "\n            "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canRefuseDraft
                        ? _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.refuseDraft },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "ban" } }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.refus")) +
                                      "\n            "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }